import { render, staticRenderFns } from "./AncientOriginBreakDownIcon.vue?vue&type=template&id=c65d74e2&scoped=true"
import script from "./AncientOriginBreakDownIcon.vue?vue&type=script&lang=js"
export * from "./AncientOriginBreakDownIcon.vue?vue&type=script&lang=js"
import style0 from "./AncientOriginBreakDownIcon.vue?vue&type=style&index=0&id=c65d74e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65d74e2",
  null
  
)

export default component.exports